export default class PDFSvg {
    constructor(svg, images = {}) {
        this.svg = svg;
        this.images = images;
    }
}
